/** InsCoder WANG.J 2026-08-17 B + Weekly Launch Offer 1 theme editor lifecycle **/

(function () {
  function initialize(root) {
    if (!root || root.dataset.custWeeklyLaunchOffer1Ready === 'true') return;
    root.dataset.custWeeklyLaunchOffer1Ready = 'true';
  }

  function initializeAll() {
    document.querySelectorAll('[data-cust-weekly-launch-offer-1]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target.querySelector('[data-cust-weekly-launch-offer-1]'));
  });
})();

/** InsCoder WANG.J 2026-08-17 E + Weekly Launch Offer 1 theme editor lifecycle **/
